import React from 'react';
import style from './SignInWithWhatsapp.module.css';
import { Button } from 'lincd-mui-base/components/Button';
import { cl } from 'lincd/utils/ClassNames';
import { packageName } from '../package.js';
import { Server } from 'lincd-server-utils/utils/Server';
import { OTPInput } from 'lincd-input/components/OTPInput';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import libphone from 'google-libphonenumber';
import { useAuth } from 'lincd-auth/hooks/useAuth';
import { asset } from 'lincd/utils/LinkedFileStorage';
import { useTranslate } from '@tolgee/react';
const PhoneNumberUtil = libphone.PhoneNumberUtil;
export const SigninWithWhatsappButton = ({ label = 'Sign in with Whatsapp', // default text button
className, // additional CSS classNames to apply to the button
onCallback, // callback function invoked when the Google authentication is successful.
restProps, onSuccess, }) => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const isPhoneValid = (phoneNumber) => {
        try {
            return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneNumber));
        }
        catch (error) {
            return false;
        }
    };
    const [otpField, setOTPField] = React.useState(false);
    const [OTPNumber, setOTPNumber] = React.useState('');
    const [user, setUser] = React.useState({});
    const [OTPRetrieve, setOTPRetrieve] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [phoneNumberField, setPhoneNumberField] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [messageData, setMessageData] = React.useState({});
    const isValid = isPhoneValid(phoneNumber);
    const auth = useAuth();
    const { t } = useTranslate();
    const prefix = 'signIn';
    const OTP_Received = (OPT_input) => {
        // if (OTP === OTPRetrieve.toString()) {
        validateOTP(phoneNumber, OPT_input);
        // } else {
        //   validateOTP(false, messageData);
        // }
        return;
    };
    const validateOTP = (phoneNumber, OPT_input) => {
        // backend already validate the OTP and return true or false here. if telephone means OTP is valid true / false
        if (phoneNumber && OPT_input) {
            Server.call(packageName, 'validateOTPWhatsapp', phoneNumber, OPT_input).then((response) => {
                if (response && response.auth) {
                    auth.updateAuth({
                        auth: response.auth,
                        accessToken: response.accessToken,
                        refreshToken: response.refreshToken,
                    });
                    onSuccess(true);
                }
                else if (response === null || response === void 0 ? void 0 : response.error) {
                    //TODO: user error message
                    alert(response.error);
                }
                else {
                    onSuccess(false);
                }
            });
            // .catch((error) => {
            //   console.error('Error signing in with WhatsApp:', error);
            //   // Handle the error appropriately (e.g., show an error message to the user)
            //   // You might want to call `onSuccess(false)` or display an error message here
            // });
        }
    };
    const handleLoading = () => {
        setLoading(false);
    };
    const sendWhatsappMessage = (phoneNumber) => {
        setLoading(true);
        if (!isValid) {
            setLoading(false);
            setPhoneNumber('');
            return;
        }
        Server.call(packageName, 'generateOTPWhatsapp', phoneNumber).then((response) => {
            const { data, otp, user } = response;
            setMessageData(data);
            setOTPField(true);
            setLoading(false);
            setOTPRetrieve(otp);
            setUser(user);
        });
    };
    // const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const inputValue = event.target.value.replace(/[^0-9]/g, '');
    //   setPhoneNumber(inputValue);
    // };
    return (React.createElement(React.Fragment, null, !otpField && !phoneNumberField ? (React.createElement(Button, { className: cl(style.root, className), onClick: () => setPhoneNumberField(true), variant: "outlined", fullWidth: true, startIcon: React.createElement("img", { src: asset('/images/wa_icon.png'), alt: "whatsapp-icon", className: style.WhatsappIcon }), ...restProps }, t(prefix + '.whatsapp', label))) : isLoading ? (React.createElement("img", { src: asset('/images/loading.gif'), className: style.loading, alt: "loading" })) : phoneNumberField && !otpField ? (React.createElement(React.Fragment, null,
        React.createElement(PhoneInput, { defaultCountry: "us", value: phoneNumber, onChange: (phoneNumber) => setPhoneNumber(phoneNumber) }),
        !isValid && phoneNumber === '' ? (React.createElement("div", { style: { color: 'red' } }, "Phone is not valid")) : null,
        React.createElement("img", { src: asset('/images/signButton.png'), className: style.signButton, onClick: () => sendWhatsappMessage(phoneNumber) }))) : (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Enter your OTP code"),
        React.createElement(OTPInput, { onClick: OTP_Received, isLoading: handleLoading })))));
};
//# sourceMappingURL=SignInWithWhatsapp.js.map